declare var window: {
  LANG: {
    searchDestinations: string,
    searchAllDestinations: string,
    searchNumberDestinations: string,
  },
  API: {
    searchResultsCount: string,
  },
};

import debounce from '../helpers/debounce';

const $hero = $('.js-hero');

const hero = {
  initialize() {
    if (!$hero.length) {
      return;
    }

    this.createListeners();
  },

  /**
   * Create listeners
   * @return {void}
   */
  createListeners() {
    const debouncedFetch = debounce(this.fetchItems.bind(this), 150);

    $hero.on('keyup', '.js-hero-input', (e: any) => {
      const val: string = e.currentTarget.value;

      if (val.length > 3) {
        debouncedFetch(val);
      } else if (val.length > 0) {
        this.changeButtonText(window.LANG.searchDestinations);
      } else {
        this.changeButtonText(window.LANG.searchAllDestinations);
      }
    });
  },

  /**
   * Fetch the number of items
   * @param {string} val
   * @return {void}
   */
  fetchItems(val) {
    $.ajax({
      url: `${window.API.searchResultsCount}${val}`,
      success: (res) => {
        if (typeof res !== 'undefined') {
          this.changeButtonText(window.LANG.searchNumberDestinations.replace('%s', res));
        }
      },
      error: () => {
        this.changeButtonText(window.LANG.searchDestinations);
      },
    });
  },

  /**
   * Change the button text
   * @param {string} text
   * @return {void}
   */
  changeButtonText(text: string) {
    $hero.find('.js-hero-btn span').text(text);
  },
};

export default hero;
